// Depencies
import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

// Components
import Footer from './components/Footer/footer';

//  Web Pages
import Inicio from './pages/inicio';
import Catalogo from './pages/catalogo';
import Carrito from './pages/carrito';
import Nosotros from './pages/nosotros';
import AvisoPrivacidad from './pages/aviso-privacidad';
import PoliticasCompra from './pages/politicas-compra';
import Success from './pages/success';
import Failure from './pages/failure';

//  Redux Functions
import { Provider } from 'react-redux';
import store from './redux/store';

// Favicon

// Import StyleSheets
import './css/style.css';

// Single Page Application
class App extends Component {
   // Version Control.
   componentDidMount() {
      const local_vs = localStorage.getItem('EXPMED_version');
      const store_vs = store.getState().version;

      if (local_vs !== store_vs && local_vs !== null) {
         store.dispatch({ type: 'VERSION', version: local_vs });
      }
   }

   render() {
      return (
         <Provider store={store}>
            <BrowserRouter>
               <div className="app">
                  {/*<Header></Header>*/}
                  {/* Router Paths  */}
                  <Route path="/" exact component={Inicio} />
                  <Route path="/inicio" exact component={Inicio} />
                  <Route path="/catalogo" exact component={Catalogo} />
                  <Route path="/carrito" exact component={Carrito} />
                  <Route path="/carrito/success" exact component={Success} />
                  <Route path="/carrito/failure" exact component={Failure} />
                  {/*<PrivateRoute path="/pedidos" exact component={Pedidos} />*/}
                  {/*<PrivateRoute path="/facturas" exact component={Facturas} />*/}
                  {/*<PrivateRoute path="/perfil" exact component={Perfil} />*/}
                  <Route path="/nosotros" exact component={Nosotros} />
                  {/*<Route path="/registro" exact component={SignIn} />*/}
                  {/*<Route path="/recuperar" exact component={Recuperar} />*/}
                  {/*<Route path="/recover/:id" exact component={RecoverPass} />*/}
                  <Route path="/privacidad" exact component={AvisoPrivacidad} />
                  <Route path="/politicas" exact component={PoliticasCompra} />
                  <Footer></Footer>
               </div>
            </BrowserRouter>
         </Provider>
      );
   }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js